import Product = FBInstant.Product;
import { TweenMax } from 'gsap';
import Core from '../../../../Core/Core';
import { TextButton } from '../../../Shared/Buttons/TextButton';
import { UIButton } from '../../../Shared/Buttons/UIButton';
import { ShopProduct } from './ShopProduct';
import { HighlightEffect } from '../../../Shared/HighlightEffect';

export class FreeGift extends ShopProduct {
    private giftBox: PIXI.Sprite;

    constructor(product: Product) {
        super(product);
        const bg = (this.bg = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/shop-bg-small']));
        bg.anchor.set(0.5);

        const buyButton = new TextButton({
            btnText: Core.local.getText('free'),
            width: bg.width,
            height: bg.height * 0.3,
        });
        buyButton.y = buyButton.height * 0.9;
        buyButton.on(UIButton.events.Trigger, this.buy.bind(this));

        const giftIcon = new PIXI.Sprite(PIXI.utils.TextureCache[`commonui/giftbox-closed`]);
        giftIcon.anchor.set(0.5);
        this.giftBox = giftIcon;

        const rays = new HighlightEffect({ texture: 'commonui/shop-rays', duration: 7 });
        giftIcon.y = -giftIcon.height * 0.3;
        rays.y = giftIcon.y + giftIcon.height * 0.1;
        rays.appear();
        //@ts-ignore
        this.addChild(bg, rays, giftIcon, buyButton);
    }

    public showGift() {
        TweenMax.to(this.giftBox, 0.3, { alpha: 0 });
    }
}
